import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

const requiredIndicatorStyles = xcss({
	color: 'color.text.danger',
	fontFamily: 'font.family.body',
	paddingInlineStart: 'space.025',
});

export const RequiredAsterisk = (): React.JSX.Element => (
	<Box
		xcss={requiredIndicatorStyles}
		aria-hidden="true"
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
		title="required"
		testId="required-asterisk"
		// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
	>
		*
	</Box>
);
